<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-inexorange hover:text-white" :href="route('products')">Producto</inertia-link>
      <span class="text-white font-medium">/       {{ form.name}} 
              </span>
    </h1>
        <img v-if="product.imageUrl" class="block ml-4 w-16 h-16 rounded-full" :src="product.imageUrl" @click="showModal"/>

    <div class="bg-transparent rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-2/4" label="Nombre" required/>
          <div  class="container pr-6 pb-8 w-full lg:w-2/4">
            <label style="color: white; font-weight: 700;" class="form-label" >Categoria:</label>
            <v-select style="color: white; background-color: inexinput;" v-model="form.category_id" :options="categoiress"  value="id" label="name">
            </v-select>
          </div>  
                    <text-input v-model="form.description" :error="form.errors.description" class="pr-6 pb-8 w-full lg:w-2/4" label="Descripción"/>
                    <file-input v-model="form.photo" :error="form.errors.photo" class="pb-8 pr-6 w-full lg:w-2/4" type="file" accept="image/*" label="Imagen" required/>
          <text-input v-model="form.price" :error="form.errors.price" class="pr-6 pb-8 w-full lg:w-1/4" label="Precio" required/>
          <text-input v-model="form.inventory" :error="form.errors.inventory" class="pr-6 pb-8 w-full lg:w-1/4" label="Inventario" required/>
          <text-input v-model="form.tax" :error="form.errors.inventory" class="pr-6 pb-8 w-full lg:w-1/4" label="Iva %" required/>
          <text-input v-model="form.commission" :error="form.errors.commission" class="pr-6 pb-8 w-full lg:w-1/4" label="Comisión" required/>



             </div>
        <div class="px-8 py-4 bg-transparent flex justify-between items-center">
          <button  class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Borrar Producto</button>          
          <loading-button :loading="form.processing" style="color: white" class="px-8 py-4 btn-indigoOrange" type="submit">Actualizar Producto</loading-button>
        </div>
      </form>
    </div>
     <Modal
  v-show="isModalVisible"
  @close="closeModal"
>
  <template v-slot:header>
   <!-- This is a new modal header.-->
  </template>

  <template v-slot:body>
       <img v-if="product.imageUrl"  :src="product.imageUrl" height="380px" width="300px"/>

  </template>

  <template v-slot:footer>
   <!-- This is a new modal footer.-->
  </template>
</Modal>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Modal from '@/Shared/Modal.vue';
import FileInput from '@/Shared/FileInput'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  metaInfo() {
    return {
      title: `${this.form.name}`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    Modal,
    vSelect,
    FileInput,
  },
  layout: Layout,
  props: {
    product: Object,
    categories: Array,
  },
  remember: 'form',
  data() {
    return {
          isModalVisible: false,
      form: this.$inertia.form({
        _method: 'put',
        name: this.product.name,
        description: this.product.description,
        photo: null,
        status: this.product.status,
       category_id: this.product.category_id,
        price: this.product.price,
        inventory: this.product.inventory,
        tax: this.product.tax,
        commission: this.product.commission,
      }),
    }
  },
  methods: {
    update() {
this.form.post(`/products/${this.product.id}`, {
        onSuccess: () => this.form.reset('password', 'photo'),
      })    },
    destroy() {
      if (confirm('Estas Seguro de Eliminar?')) {
        this.$inertia.delete(this.route('products.destroy', this.product.id))
      }
    },
      showModal() {
        this.isModalVisible = true;
      },
      closeModal() {
        this.isModalVisible = false;
      },
  },
}
</script>
